module.exports = __webpack_public_path__ + "img/empleados.5f47faa3.png";